<app-inbox-dial-phone-button [byPhone]="true" [canDial]="canDial" [doDial]="doDial"></app-inbox-dial-phone-button>
